import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/competitors/filter'; // Importing Filter component
import Table from 'views/competitors/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * CompetitorsView class extending JetView to create a view for competitors.
 */
export default class CompetitorsView extends JetView {
    /**
     * Configures the layout and components of the CompetitorsView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            type: 'wide',
            minWidth: 200,
            rows: [], // Placeholder for future rows
        };
        const toolbar = {
            view: 'toolbar', // Toolbar component
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Page size options
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text for export
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable'); // Reference to data table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Competidores'), // Filename for export
                                    ignore: {
                                        Action: true,
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Competidores'), // Filename for export
                                        autowidth: true,
                                        ignore: {
                                            Action: true,
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            css: 'int-left', // CSS class for left section
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Apply current theme
                    elements: [
                        { view: 'label', label: _('Competidores') }, // Label for competitors
                        {
                            type: 'wide',
                            css: 'close-bottom', // CSS class for close button
                            cols: [
                                {
                                    view: 'icon', // Icon for closing the view
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                Filter, // Include Filter component
                Table, // Include Table component
                toolbar, // Include toolbar
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean type for the view
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive layout
                    type: 'wide',
                    cols: [
                        left, // Left section with components
                        { id: 'res', view: 'resizer' }, // Resizer for layout adjustment
                    ],
                },
            ],
        };
    }
}

// FILE DOCUMENTED
